"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetBookingItemQuantityExtraReducers = void 0;
const tslib_1 = require("tslib");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const services_1 = tslib_1.__importDefault(require("../../../../services"));
const getById_1 = tslib_1.__importDefault(require("../getById"));
const __model__1 = tslib_1.__importDefault(require("./__model__"));
/**
 * @function resetBookingItemQuantity
 * @description force reset to remaining quantity of booking item
 * If not available, will remove this booking item from booking
 */
const resetBookingItemQuantity = toolkitRaw.createAsyncThunk('bookings/fetch_reset_booking_items_quantity', async ({ bookingInternalId, options }, { rejectWithValue, getState, dispatch }) => {
    var _a;
    try {
        const state = getState();
        const bookingItemState = ((_a = state.bookings.booking.data) === null || _a === void 0 ? void 0 : _a.booking_items) || [];
        let bookingItems = Array.from(bookingItemState).map((item) => ({
            id: item.id,
            force_quantity_available: true,
        }));
        if ((options === null || options === void 0 ? void 0 : options.bookingItemId) && Array.isArray(options === null || options === void 0 ? void 0 : options.bookingItemId)) {
            bookingItems = bookingItems.filter((item) => Array.from((options === null || options === void 0 ? void 0 : options.bookingItemId) || []).includes(item.id));
        }
        const payload = new __model__1.default(bookingItems);
        await services_1.default.patch(`/api/saas/me/bookings/${bookingInternalId}`, payload.data);
        const responseUpdateBooking = await dispatch((0, getById_1.default)({ id: bookingInternalId }));
        return responseUpdateBooking.payload;
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const resetBookingItemQuantityExtraReducers = (builder) => {
    builder.addCase(resetBookingItemQuantity.pending, (state) => {
        state.booking.slices.items.loading = true;
    });
    builder.addCase(resetBookingItemQuantity.fulfilled, (state) => {
        state.booking.slices.items.loading = false;
        state.booking.slices.items.error = false;
    });
    builder.addCase(resetBookingItemQuantity.rejected, (state) => {
        state.booking.slices.items.loading = false;
        state.booking.slices.items.error = true;
    });
};
exports.resetBookingItemQuantityExtraReducers = resetBookingItemQuantityExtraReducers;
exports.default = resetBookingItemQuantity;
//# sourceMappingURL=index.js.map